import React from 'react';
import Button from '@material-ui/core/Button';
import Radio from '@material-ui/core/Radio';
import { withStyles } from '@material-ui/core/styles';

export const DefaultButton = withStyles({
  root: {
    boxShadow: 'none',
    textTransform: 'none',
    fontFamily: 'Roboto, sans-serif',
    fontSize: 14,
    padding: '6px 12px',
    border: '1px solid',
    lineHeight: 1.5,
    '&:focus': {
      outline: 'none'
    },
    '&:disabled': {
      color: '#dad7d7ff !important',
      borderColor: '#dad2d2ff !important',
      cursor: 'not-allowed',
    },
  },
})(Button);

export const LinearCalendarButton = withStyles({
  root: {
    border: '10px',
    boxSizing: 'border-box',
    display: 'inline-block',
    fontFamily: 'Roboto, sans-serif',
    cursor: 'pointer',
    textDecoration: 'none',
    margin: '0px',
    padding: '0px',
    outline: 'none',
    fontSize: '0px',
    fontWeight: 'inherit',
    position: 'relative',
    overflow: 'visible',
    transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    minWidth: '33.3333px !important',
    height: '48px !important',
    background: 'none',
    '&:focus': {
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
      outline: 'none'
    }
  },
})(Button);


export const RadioButton = withStyles({
  root: {
    color: '#888888',
    '&$checked': {
      color: '#009688',
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);
